import React from 'react';
import {Outlet} from "react-router";
const AdminAdvertising = () => {
    return <Outlet>Advertising view ,available</Outlet>
};

export default AdminAdvertising;